import { CcModal } from "@utp/components-react";
import { Button } from "@utp/react-components-prod";
import useResponsive from "hooks/useResponsive";
import { useBlocker } from "react-router-dom";
import { useConfigPromp } from "routes/context";

const ModalPromp = () => {
  const { isBlocking} = useConfigPromp();
  const { isMinorTablet } = useResponsive();

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isBlocking &&
      currentLocation.pathname !== nextLocation.pathname
  );

  const handleCancel = () => {
    if (blocker.reset) {
      blocker.reset();
    }
  };

  const handleConfirm = () => {
    if (blocker.proceed) {
      blocker.proceed();
    }
  };

  return (
    <div>
      <CcModal
        visible={blocker.state === "blocked"}
        onCancel={handleCancel}
        hideCloseButton
      >
        <div className="mb-lg">
          <h2 className="font-black text-heading-02 text-color-02 mb-lg text-center">
            ¿Deseas salir sin finalizar este examen?
          </h2>
          <p className={`text-center text-color-02 leading-snug ` }>
            Se guardarán las respuestas hasta donde avanzaste. <br />
            <span className={` ${isMinorTablet ? 'hidden' : 'block'}` }>El tiempo seguirá corriendo aunque salgas del examen.</span>
          </p>
        </div>
        <div className="flex justify-center gap-lg modal-buttons flex-wrap">
          <Button
            text="No, regresar"
            color="primary"
            type="outline"
            data-testid="btn-cancel"
            onClick={() => handleCancel()}
          />
          <Button
            text="Sí, salir"
            color="primary"
            data-testid="btn-confirm"
            onClick={() => handleConfirm()}
          />
        </div>
      </CcModal>
    </div>
  );
};
export default ModalPromp;
